(() => {
  function fallbackCard(item, createFavoriteCard) {
    const card = createFavoriteCard(item);
    card.setAttribute('data-gd-recent-card', '');
    card.querySelector('.gd-product-card__remove')?.remove();
    const eyebrow = card.querySelector('.gd-product-card__eyebrow');
    if (eyebrow) card.insertBefore(eyebrow, card.firstChild);
    const media = card.querySelector('.gd-product-card__media');
    const favorite = card.querySelector('.gd-product-card__favorite');
    if (media) {
      const wrapper = document.createElement('div');
      wrapper.className = 'gd-product-card__media-wrapper';
      card.insertBefore(wrapper, media);
      wrapper.appendChild(media);
      if (favorite) wrapper.appendChild(favorite);
      if (item.comparePrice > item.price && item.price > 0) {
        const discount = document.createElement('span');
        discount.className = 'gd-product-card__badge gd-product-card__badge--discount';
        discount.textContent = '-' + Math.round((item.comparePrice - item.price) * 100 / item.comparePrice) + '%';
        wrapper.appendChild(discount);
      }
    }
    const body = card.querySelector('.gd-product-card__body');
    const price = body?.querySelector('.gd-product-card__price');
    if (body && price) {
      const priceWrapper = document.createElement('div');
      priceWrapper.className = 'gd-product-card__price-wrapper';
      body.insertBefore(priceWrapper, price);
      priceWrapper.appendChild(price);
      const compare = price.querySelector('s');
      if (compare) {
        const label = document.createElement('span');
        label.className = 'gd-product-card__compare-price';
        label.append('De ', compare, ' por');
        price.insertBefore(label, price.firstChild);
      }
      const terms = body.querySelector('.gd-product-card__terms');
      if (terms) priceWrapper.appendChild(terms);
    }
    return card;
  }

  window.gdRecentCard = (item, rootUrl, hydrateFavorite, createFavoriteCard) => {
    const url = rootUrl + 'products/' + encodeURIComponent(item.handle) + '?section_id=gd-recent-product-card';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(response => {
        if (!response.ok) throw new Error('Card indisponível');
        return response.text();
      })
      .then(html => {
        const container = document.createElement('div');
        container.innerHTML = html;
        const card = container.querySelector('[data-gd-product-card]');
        if (!card || card.dataset.gdProductHandle !== item.handle) throw new Error('Card não encontrado');
        card.setAttribute('data-gd-recent-card', '');
        const dialog = card.querySelector('[data-gd-notify-dialog]');
        const trigger = card.querySelector('[data-gd-notify-open]');
        if (dialog && trigger) {
          dialog.id += '-recent';
          trigger.setAttribute('data-gd-notify-open', dialog.id);
          const email = dialog.querySelector('input[type="email"]');
          const label = dialog.querySelector('label[for]');
          if (email?.id) {
            email.id += '-recent';
            if (label) label.setAttribute('for', email.id);
          }
        }
        return card;
      })
      .catch(() => hydrateFavorite(item).then(fresh => fallbackCard(fresh, createFavoriteCard)));
  };
})();